import apiRequest from "../../functions/api";

export const fetchNewsUpdates = (statement, accessToken, typeEntry, entryIdForNews, interaction) => {
  return new Promise((resolve, reject) => {
    const payload = {
      statement: statement,
      typeEntry: typeEntry,
      appType: "ESS",
      key: entryIdForNews,
      interaction: interaction,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest(
      "POST",
      "news",
      payload,
      headers,
      (response) => {
        if (response.status === 200) {
          resolve(response.data);
        } else {
          if (response) {
            reject(response.data.message);
          } else {
            reject("Keine Internetverbindung");
          }
        }
        resolve();
      },
      () => {
        reject("Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.");
      }
    );
  });
};
